'use strict';
import * as dom from './scripts/lib/dom.js';
import * as asideFollowScroll from './scripts/asideFollowScroll.js'
const forEachSlotDiv = (cb, preloadedDivs) => {
    const divs = (preloadedDivs !== null) ? preloadedDivs : document.querySelectorAll('.js-dfp-container');
    // const divs = document.querySelectorAll('.js-dfp-container');
    // console.log(divs);
    // console.log(preloadedDivs);

    for (let div of Array.from(divs)) {
        // console.log(div);
      cb(div);
    }
}

const defineSlot = (div, gt) => {
    // console.log('defineSlot');
    
    if (div.classList.contains('dfp-container-defined')) {
        return;
    }

    let platform = 'mobile';
    const displayWidth = window.innerWidth;

    if (displayWidth >= 1360) {
        platform = 'fullhd';
    } else if (displayWidth >= 1024){
        platform = 'desktop';
    }

    const slot = div.getAttribute('data-slot');
    // console.log(div.getAttribute('data-targeting'));


    const platformSizes = div.getAttribute(`data-sizes-${platform}`);
    const rawSizes = (platformSizes)
                      ? platformSizes
                      : div.getAttribute('data-sizes');

    const sizes = JSON.parse(rawSizes);
    let targeting = div.getAttribute('data-targeting');
    const id = div.getAttribute('id');
    let asideAdsControlRuned = false;
    let footerdsControlRuned = false;
    console.log(div.classList.contains('js-dfp-footer'));
    if (!targeting || targeting !== '') {

        if(div.classList.contains('js-dfp-footer') && !div.classList.contains('dfp-container-defined')) {
            console.log('footer slot');
            gt
            .defineSlot(slot, sizes, id)
            .addService(gt.pubads());
            div.classList.add('dfp-container-defined');

            gt.pubads(div).addEventListener('slotOnload', function(event) {
                console.log('slotOnload');
                if (footerdsControlRuned === false) {
                    console.log('toggleFooterFixed');
                    const footerFixed = document.querySelector('.o-ads-fixed-footer');
                    if(!footerFixed.classList.contains('active')) {
                        console.log(footerFixed);
                        dom.addClass(footerFixed, 'active');
                        footerdsControlRuned = true;
                    }
                }
            });
        } else {
            gt
            .defineSlot(slot, sizes, id)
            .addService(gt.pubads());
            div.classList.add('dfp-container-defined');
        }
        return;
    } else {
        // console.log('with targeting');
    }

    if (!targeting || targeting !== '') {

        if(div.classList.contains('js-dfp-aside') && !div.classList.contains('dfp-container-defined')) {

            gt
            .defineSlot(slot, sizes, id)
            .addService(gt.pubads());
            div.classList.add('dfp-container-defined');

            gt.pubads(div).addEventListener('slotOnload', function(event) {
                // console.log('slotOnload');
                if (asideAdsControlRuned === false) {
                    asideFollowScroll.followScroll();
                    asideAdsControlRuned = true;
                }
            });

            gt.pubads(div).addEventListener('impressionViewable', function(event) {
                // console.log('ImpressionViewableEvent');
                setTimeout(function(){
                    asideFollowScroll.followScroll();
                }, 2100);

            });
        } else {
            gt
            .defineSlot(slot, sizes, id)
            .addService(gt.pubads());
            div.classList.add('dfp-container-defined');
        }
        return;
    } else {
        // console.log('with targeting');
    }

    targeting = targeting.replace(/'/g, '"');
    targeting = JSON.parse(targeting)[0];

    gt
    .defineSlot(slot, sizes, id)
    .addService(gt.pubads())
    .setTargeting(targeting[0], targeting[1]);
    div.classList.add('dfp-container-defined');
    gt.pubads()
}

const initializeSlots = (divs = null) => {
    

    const body = document.querySelector('body');

    if (body.classList.contains('dont-load-ads')) {
        console.log('dont initializeSlots');
        return
    }

    console.log('initializeSlots');

    const showSlot = (div, gt) => gt.display(div.getAttribute('id'));

        const defineSlots = gt => forEachSlotDiv(div => {
            defineSlot(div, gt);
            gt.pubads().collapseEmptyDivs();
            gt.enableServices();
        }, divs);

        const showSlots = gt => forEachSlotDiv(div => {
            if (div.classList.contains('dfp-container-showed')) {
                return;
            }

            showSlot(div, gt);
            div.classList.add('dfp-container-showed');
        }, divs);

        let googletag = (typeof window.googletag ===  'undefined') ? {} : window.googletag;
        const dfpIsLoaded = (googletag.defineSlot !== 'undefined');

        if (dfpIsLoaded) {
            // googletag.pubads().setTargeting('canal-patrocinado', 'b.blend');
            defineSlots(googletag);
            showSlots(googletag);
            return;
        }

        googletag.cmd = googletag.cmd || [];
        googletag.cmd.push(() => {
            // googletag.pubads().setTargeting('canal-patrocinado', 'b.blend');
            defineSlots(window.googletag);
            showSlots(googletag);
        });
}

window.addEventListener('load', function() {
    initializeSlots();
});

export { initializeSlots };


